import { render } from "./TopNavigationButton.vue?vue&type=template&id=e90df4a4&scoped=true"
import script from "./TopNavigationButton.vue?vue&type=script&lang=js"
export * from "./TopNavigationButton.vue?vue&type=script&lang=js"

import "./TopNavigationButton.vue?vue&type=style&index=0&id=e90df4a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90df4a4"]])

export default __exports__